import { MenuItem } from "@mui/material";
import React, { useState } from "react";
import { GapContainer } from "../../../components/card/styled";
import BarekamText from "../../../components/text";
import { Message, MessageSections } from "../../../components/message/message";
import { BarekamCard } from "../../../components/card/card";
import { ConfirmationDialog } from "../../../components/dialogs/confirmation-dialog";
import { ThreeDot } from "../../../components/three-dot/three-dot";
import { Recipient } from "../../../shared/models/user/recipient/recipient";

export const LimitedRecipientCard = ({ recipient, onClick, onRemove }: RecipientCardProps) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const CardContent = () => (
        <>
            <GapContainer>
                <BarekamText variant={"s"} opaque>
                    <Message messageKey={'weight'} sectionId={MessageSections.USER} />
                    {':'}
                </BarekamText>

                <BarekamText variant={"s"} maxWidth={15} width={'100%'}>
                    {' '}
                    {recipient.monthlyLimit?.weightLimitPerParcel
                        ? <>
                            {recipient.monthlyLimit.weightLimitPerParcel}
                            {' '}
                            <Message messageKey={'kg'} sectionId={MessageSections.MAIN} />
                        </>
                        : <Message messageKey={'no_limit'} sectionId={MessageSections.USER} />
                    }
                </BarekamText>
            </GapContainer>

            <GapContainer>
                <BarekamText variant={"s"} opaque>
                    <Message messageKey={'price'} sectionId={MessageSections.USER} />
                    {': '}
                </BarekamText>

                <BarekamText variant={"s"} maxWidth={15} width={'100%'}>
                    {' '}
                    {recipient.monthlyLimit?.priceLimitPerParcel
                        ? <>
                            {recipient.monthlyLimit.priceLimitPerParcel}
                            {' '}
                            <Message messageKey={'amd'} sectionId={MessageSections.MAIN} />
                        </>
                        : <Message messageKey={'no_limit'} sectionId={MessageSections.USER} />
                    }
                </BarekamText>
            </GapContainer>

            {/*DISABLED BECAUSE ORDERS HAVE ONLY 1 PRODUCT*/}
            {/*<GapContainer>*/}
            {/*    <BarekamText variant={"s"} opaque>*/}
            {/*        <Message messageKey={'orders_count'} sectionId={MessageSections.USER}/>*/}
            {/*        {': '}*/}
            {/*    </BarekamText>*/}

            {/*    <BarekamText variant={"s"} maxWidth={15} width={'100%'}>*/}
            {/*        {recipient.monthlyLimit?.pieceCountLimitPerRecipient*/}
            {/*            ? <>*/}
            {/*                {recipient.monthlyLimit.pieceCountLimitPerRecipient}*/}
            {/*            </>*/}
            {/*            : <Message messageKey={'no_limit'} sectionId={MessageSections.USER}/>*/}
            {/*        }*/}
            {/*    </BarekamText>*/}
            {/*</GapContainer>*/}
        </>
    )

    const CardHeader = () => (
        <BarekamText variant={"1rem"} fontWeight={700} width={'unset'}>
            {recipient.firstName} {recipient.lastName}
        </BarekamText>
    )

    return (
        <>
            <BarekamCard headerLabel={<CardHeader />}
                headerAction={
                    <GapContainer>
                        <ThreeDot>
                            <MenuItem onClick={() => setDialogOpen(true)}>
                                <Message messageKey={'delete'} sectionId={MessageSections.MAIN} />
                            </MenuItem>
                            <MenuItem onClick={() => onClick?.()}>
                                <Message messageKey={'edit'} sectionId={MessageSections.ORDERS} />
                            </MenuItem>
                        </ThreeDot>
                    </GapContainer>
                }
                content={<CardContent />}
                onClick={onClick} />

            <ConfirmationDialog open={dialogOpen}
                handleClose={(confirmed) => {
                    confirmed && onRemove && onRemove();
                    setDialogOpen(false);
                }}
                titleKey={'recipient_delete_monthly_limits'}
                descriptionKey={'recipient_delete_monthly_limits_description'}
                isRemove />
        </>
    );
}

interface RecipientCardProps {
    recipient: Recipient,
    onClick?: () => void;
    onRemove?: () => void;
}
